import React from 'react';

import PropTypes, {InferProps} from 'prop-types';

import {Layout} from 'commons/models';
import {OnboardingMenuContext} from 'context';
import {GeolocationInfo, ModuleItem} from 'commons/types/Types';
import {INITIAL_MODULES} from 'commons/constants';

const defaultContextValue = {
    menu: [...INITIAL_MODULES],
    personType: '',
    foreign: false,
    expedientId: 1,
    kycId: 1,
    fatherKycId: 0,
    layout: {
        layoutId: 0,
        layoutDescription: '',
        views: [],
    },
    geolocationData: {
        latitude: null,
        longitude: null,
    },
};

EfeMenuProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

function EfeMenuProvider(props: InferProps<typeof EfeMenuProvider.propTypes>) {
    const {children} = props;
    const [menu, setMenu] = React.useState<ModuleItem[]>(defaultContextValue.menu);
    const [personType, setPersonType] = React.useState<string>(defaultContextValue.personType);
    const [foreign, setForeign] = React.useState<boolean>(defaultContextValue.foreign);
    const [layout, setLayout] = React.useState<Layout>(defaultContextValue.layout);
    const [geolocationData, setGeolocationData] = React.useState<GeolocationInfo>(
        defaultContextValue.geolocationData
    );

    const [expedientId, setExpedientId] = React.useState<number>(defaultContextValue.expedientId);
    const [kycId, setKycId] = React.useState<number>(defaultContextValue.kycId);
    const [fatherKycId, setFatherKycId] = React.useState<number>(defaultContextValue.fatherKycId);

    const updateMenu = (data: ModuleItem[]) => {
        setMenu(Array.from(new Set([...INITIAL_MODULES, ...data])));
    };

    const updateLayout = (data: Layout) => {
        setLayout(data);
    };

    const resetMenuProvider = () => {
        setMenu(defaultContextValue.menu);
        setPersonType(defaultContextValue.personType);
        setForeign(defaultContextValue.foreign);
        setLayout(defaultContextValue.layout);
        setExpedientId(defaultContextValue.expedientId);
        setKycId(defaultContextValue.kycId);
        setFatherKycId(defaultContextValue.fatherKycId);
        setGeolocationData(defaultContextValue.geolocationData);
        updateMenu([...INITIAL_MODULES]);
    };

    return (
        <OnboardingMenuContext.Provider
            value={{
                menu,
                updateMenu,
                personType,
                setPersonType,
                foreign,
                setForeign,
                layout,
                updateLayout,
                expedientId,
                setExpedientId,
                kycId,
                setKycId,
                fatherKycId,
                setFatherKycId,
                resetMenuProvider,
                geolocationData,
                setGeolocationData,
            }}>
            {children}
        </OnboardingMenuContext.Provider>
    );
}

export default EfeMenuProvider;
